import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export const useAnnouncementState = () => {
  const [showAnnouncements, setShowAnnouncements] = useState(false);
  const location = useLocation();
  const hasCheckedRef = useRef(false);

  useEffect(() => {
    if (hasCheckedRef.current) return;

    const shouldShowFromState = location.state?.showAnnouncements;
    const shouldShowFromSession =
      sessionStorage.getItem("showLoginAnnouncements") === "true";

    if (shouldShowFromState || shouldShowFromSession) {
      hasCheckedRef.current = true;
      setShowAnnouncements(true);

      if (shouldShowFromSession) {
        sessionStorage.removeItem("showLoginAnnouncements");
      }

      if (shouldShowFromState) {
        window.history.replaceState({}, document.title);
      }
    }
  }, [location]);

  const triggerAnnouncements = () => {
    setShowAnnouncements(true);
  };

  const clearAnnouncements = () => {
    setShowAnnouncements(false);
    hasCheckedRef.current = false;
  };

  return {
    showAnnouncements,
    triggerAnnouncements,
    clearAnnouncements,
  };
};
